import api from '../../configuration/api'

export const artists = {
  list: (data) => api.get('artists', data),
  getOne: (id, data) => api.get('artists/' + id, data),
  getOneBySlug: (slug, data) => api.get('artists/slug/' + slug, data),
};
